import { Typography } from '@breetometer/components';
import { CopyIcon } from 'BreetAssets';
import { copyToClipboard } from 'BreetHelpers';

import type { IAccountDetailsItem } from '../../DialogFundRequest.helpers';

export const AccountDetailsItem = ({ label, value, loading }: IAccountDetailsItem) => (
	<div className='account-details-item'>
		<Typography
			as='label'
			className='color-primary-100'
		>
			{label}
		</Typography>
		<div className='account-details-value'>
			{loading ? (
				<div className='global-skeleton'>{label}</div>
			) : (
				<>
					<Typography className='color-tertiary-400'>{value}</Typography>
					<CopyIcon
						variant='colored'
						onClick={copyToClipboard(value, `${label} copied`)}
						className='cursor_pointer'
					/>
				</>
			)}
		</div>
	</div>
);
